import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { UserService } from 'src/app/_services';
import { HeaderService } from 'src/app/_services/header.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { Community, CommunityType } from '../community/community.model';
import { CommunityService } from '../community/community.service';

@Component({
  selector: 'app-practices-list',
  templateUrl: './practices-list.page.html',
  styleUrls: ['./practices-list.page.scss'],
})
export class PracticesListPage implements OnInit {

  permissionAdmin = false;
  permissionAdd = false;

  newsVisible: Community[];
  allNewsVisible = false;
  newsVisibleInitCount = 5;
  newsAddVisible = 5;

  comType: number = CommunityType.GoodPracticesList;

  subs: Subscription[] = [];

  @ViewChild('searchBar')
  searchBar;

  headerInit: HeaderModel = {
    title: 'MENU.PRACTICES_LIST',
    showOnTablet: true,
    shouldHasMobileSegments: false,
  };

  constructor(
    public communityServ: CommunityService,
    private userServ: UserService,
    public p: ThisPlatform,
    public platform: Platform,
    private headerServ: HeaderService,
  ) { }

  async ngOnInit() {
    this.permissionAdmin = await this.userServ.hasRolesAsync([
      'community.admin',
    ]);

    this.permissionAdd = this.userServ.hasRoles([
      'community.information.add',
    ]);

    this.refreshCommunities();
  }

  ionViewWillEnter() {
    this.refreshCommunities();
    this.headerServ.setHeaderInit(this.headerInit);
  }
  
  refreshCommunities() {
    this.communityServ
      .getComunitiesType(Number(this.comType))
      .subscribe((res: Community[]) => {
        this.communityServ.communities = res;
        this.communityServ.communitiesFilter = res;
        this.searchNews();
      });
  }

  /**
   * Funkcja pobierająca posty dotyczące Dobrych Praktyk
   */
  getNews() {
    this.subs.push(
      this.communityServ
        .getComunitiesType(this.comType)
        .subscribe((c: Community[]) => {
          this.communityServ.communities = c;
          this.communityServ.communitiesFilter = c;
          this.searchNews();
        })
    );
  }

  /**
   * Funkcja wyszukująca posty
   */
  searchNews() {
    if (this.searchBar.ngModel && this.searchBar.ngModel.length > 0) {
      this.communityServ.communitiesFilter = this.communityServ.communities.filter(
        (item) => {
          return (item.title + ' ' + (item.description ? item.description : ''))
            .toUpperCase()
            .includes(this.searchBar.ngModel.toUpperCase());
        }
      );
    } else {
      this.communityServ.communitiesFilter = this.communityServ.communities;
    }
    const rows = this.communityServ.communitiesFilter;

    if (rows.length > this.newsVisibleInitCount) {
      this.newsVisible = rows.slice(0, this.newsVisibleInitCount);
      this.allNewsVisible = false;
    } else {
      this.newsVisible = rows;
      this.allNewsVisible = true;
    }
  }

  /**
   * Funkcja ładująca więcej postów
   */
  showMoreNews() {
    const from = this.newsVisible.length;
    let to = from + 5;
    const length = this.communityServ.communitiesFilter.length;

    if (to >= length) {
      to = length;
      this.allNewsVisible = true;
    }

    for (let i = from; i < to; i++) {
      const row = this.communityServ.communitiesFilter[i];
      this.newsVisible.push(row);
    }
  }
  /**
   * lazy loading
   * @param event $event
   */
  loadNews(event) {
    window.setTimeout(() => {
      this.showMoreNews();
      event.target.complete();
    }, 500);
  }

  ngOnDestroy(): void {
    for (const e of this.subs) {
      e.unsubscribe();
    }
  }

}
